import React from 'react';
import styles from './staff.module.scss';
import useLanguagesHooks from '../../../../../Components/Languages/setLanguage-hooks';
import NoData from '../../../../../Components/NoData/noData';
import CustomDialog from '../../../../../Components/Dialog/customDialog';
import useStaffHooks from './staff-hook';
import EmployeeCard from './Cards/EmployeeCard/employeeCard';
import { ButtonTypes, StaffScreenTypes } from '../../../../../Interfaces/componentTypes';
import Button from '../../../../../Components/Button/button';
import { AddUser, BackArroww, Filter } from '../../../../../Assets/Icons';
import { AddUserIcon } from '../../../../../Components/IconComponents';
import AutoComplete from '../../../../../Components/Inputs/AutoComplete/autoComplete';
import SearchMenu from '../../../../../Components/Inputs/SearchInput/SearchMenuItem/searchMenu';
import { useDirectoriesHook } from '../../../../../Hooks/hooks';

interface IProps {
    companyId: number
};

const Staff: React.FC<IProps> = ({ companyId }) => {
    const {
        open,
        staff,
        staffList,
        screenType,
        selectedRole,
        selectedUser,
        dialogComponent,
        rolesFilterValues,
        onBack,
        onFilter,
        onSelectUser,
        onCloseDialog,
        onOpenAddDialog,
        setSelectedRole,
        onOpenEditDialog,
    } = useStaffHooks(companyId);
    const { t } = useLanguagesHooks();

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.headerTitle}>
                    <p>
                        {
                            t('My_Business.Personal.Header')
                        }
                    </p>
                </div>
                {
                    staff.length > 0
                    &&
                    <div className={styles.pageActionsBox}>
                        {
                            screenType === StaffScreenTypes.EMPLOYE
                                ?
                                <div className={styles.backBox} onClick={onBack}>
                                    <img src={BackArroww} alt='bak.svg'/>
                                    <p>
                                        {t('My_Business.Main')}
                                    </p>
                                </div>
                                :
                                <div className={styles.filterBox}>
                                    <img src={Filter} alt='filter.svg'/>
                                    <div className={styles.filterInput}>
                                        <AutoComplete
                                            data={rolesFilterValues}
                                            onChange={(value) => {
                                                setSelectedRole(value); 
                                                onFilter(value?.id as string); 
                                            }}
                                            value={selectedRole}
                                            showTextError={false}
                                            style={styles.filterInput}
                                        />
                                    </div>
                                    <div className={styles.filterInput}>
                                    </div>
                                </div>
                        }
                    </div>
                }
            </div>
            {
                staff.length > 0
                    ?
                    <div className={styles.body}>
                        {screenType === StaffScreenTypes.LIST
                            ?
                            <>
                            {staffList.length > 0
                            ?
                            <>
                              {
                                staffList.map((item, index) => {
                                    return (
                                        <EmployeeCard
                                            key={index}
                                            data={item}
                                            index={index}
                                            onOpen={onSelectUser}
                                            onEdit={onOpenEditDialog}
                                        />
                                    )
                                })
                            }
                            <Button
                                buttonType={ButtonTypes.ButtonWithIcon}
                                leftIcon={
                                    <AddUserIcon
                                        width={20}
                                        height={20}
                                        color='white'
                                    />}
                                title={t('Buttons.Add')}
                                onClick={onOpenAddDialog}
                                buttonStyle={styles.addButton}
                            />
                            </>
                            :
                            <div className={styles.noResult}>
                            <NoData
                                buttonTitle={t('Buttons.Add')}
                                message={t('No_Data.No_Search')}
                            />
                        </div>
                            }
                              
                            </>
                            :
                            selectedUser &&
                            <div>{selectedUser.first_name}</div>
                        }

                    </div>
                    :
                    <div className={styles.noData}>
                        <NoData
                            withButton={true}
                            buttonTitle={t('Buttons.Add')}
                            message={t('My_Business.Personal.No_Data')}
                            onPressButton={onOpenAddDialog}
                        />
                    </div>
            }
            <CustomDialog
                open={open}
                onClose={onCloseDialog}
                children={dialogComponent}
            />
        </div>
    )
}

export default Staff
